import { render, staticRenderFns } from "./question_block.vue?vue&type=template&id=67953d9a"
import script from "./question_block.vue?vue&type=script&lang=js"
export * from "./question_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports